import styled from 'styled-components';

import { colors, radius } from '../../styles/tokens';

export const Container = styled.div`
  width: 100%;
  min-height: 74px;

  display: flex;
  align-items: center;
  gap: 16px;

  padding: 12px 20px;
  border-radius: ${radius.md};

  background-color: ${colors.surfaceContainerLow};
  border: 1px solid transparent;

  transition: background-color 0.2s;

  &:hover {
    background-color: ${colors.surfaceContainer};
  }

  @media (max-width: 1199px) {
    flex-wrap: wrap;
  }
`;

export const ContainerImg = styled.div`
  flex-shrink: 0;
  width: 44px;
  height: 44px;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  border-radius: ${radius.sm};

  background-color: ${colors.surfaceContainerHigh};

  img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
  }
`;

export const Info = styled.div`
  flex: 1;
  min-width: 0;

  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const Name = styled.span`
  font-size: 15px;
  font-weight: 700;
  color: ${colors.onSurface};

  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const Subtitle = styled.span`
  font-size: 10px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;

  color: ${colors.onSurfaceVariant};
`;

export const Status = styled.div`
  flex-shrink: 0;
  width: 110px;

  display: flex;
  align-items: center;
  gap: 8px;

  span {
    font-size: 13px;
    color: ${colors.onSurface};
  }

  @media (max-width: 1199px) {
    width: auto;
  }
`;

interface statusDotProps {
  is_active?: boolean;
}

export const StatusDot = styled.div<statusDotProps>`
  width: 8px;
  height: 8px;
  border-radius: ${radius.full};

  background-color: ${({ is_active }) =>
    is_active ? '#32a54a' : colors.error};
`;

export const ManageButton = styled.button`
  flex-shrink: 0;

  padding: 8px 16px;
  border-radius: ${radius.DEFAULT};
  border: 1px solid ${colors.outlineVariant}80;

  background-color: transparent;
  color: ${colors.onSurface};

  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;

  cursor: pointer;
  transition: all 0.2s;

  &:hover {
    background-color: ${colors.surfaceContainerHigh};
  }
`;
